import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Divider,
  Checkbox,
  Radio,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
  ListItemText,
  TextField,
  Tooltip,
  FormControlLabel,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axiosInstance from '../../axios/axios';
import { END_POINTS } from '../../shared';
import { toast } from 'react-toastify';

const AssetComplianceReportDrawer = ({ onClose, assetData, isCloud }: { onClose: () => void, assetData?: any, isCloud?: boolean }) => {
  console.log(assetData, 'assetData from AssetComplianceReportDrawer');
  const isCloudResource = isCloud ?? (assetData?.module === "cloud" || Boolean(assetData?.account_id) || Boolean(assetData?.resource_type));
  const [selectedBenchmarks, setSelectedBenchmarks] = useState<string[]>([]);
  const [search, setSearch] = useState('');
  const [controls, setControls] = useState({ failed: "false", passed: "true" });
  const [riskAccepted, setRiskAccepted] = useState('exclude');
  const [controlDescriptions, setControlDescriptions] = useState('exclude');
  const [controlRemediations, setControlRemediations] = useState('exclude');
  const [reportFormat, setReportFormat] = useState('pdf');
  const [benchmarks, setBenchmarks] = useState<{ id: string; name: string }[]>([]);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [parameter_impact, setParameterImpact] = useState('exclude');
  const [parameter_log_output, setParameterLogOutput] = useState('exclude');
  const MAX_VISIBLE = 3;

  useEffect(() => {
    if (assetData?.id) {
      axiosInstance.get(`securityscan/benchmark-values?device_id=${assetData.id}`)
        .then(response => {
          if (Array.isArray(response.data?.data)) {
            setBenchmarks(response.data.data);
          }
        })
        .catch(error => {
          console.error('Error fetching benchmark values:', error);
        });
    }
  }, [assetData?.id]);

  const filteredBenchmarks = benchmarks.filter(b => b.name.toLowerCase().includes(search.toLowerCase()));

  const saveFile = (blob: Blob, fileName: string) => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const objectUrl = window.URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(objectUrl);
    document.body.removeChild(a);
  };

  const handleDownloadReport = async () => {
    console.log({
      selectedBenchmarks,
      controls,
      riskAccepted,
      controlDescriptions,
      controlRemediations,
      reportFormat,
    });
    
    setDownloadLoading(true);
    
    const payload = {
      report_format: reportFormat,
      asset_ids: [assetData.id],
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      type: "asset_report",
      module: isCloudResource ? "cloud" : "on_premise",
    };
    console.log(payload, 'payload');
    
    try {
      const response = await axiosInstance.post(END_POINTS.REPORT_DOWNLOAD, payload);
      if(response.status === 200){
        toast.success("Report request submitted, please check Reports section.");
      }
      onClose();
    } catch (error) {
      console.error('Error making API call:', error);
      toast.error("Failed to download the report.");
    } finally {
      setDownloadLoading(false);
    }
  };

  return (
    <Box sx={{ pl: 3, width: 400,overflowY:'hidden', }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" fontWeight={700}>{isCloudResource ? "Resource Report" : "Asset Report"}</Typography>
        <IconButton onClick={onClose}><CloseIcon /></IconButton>
      </Box>
      {/* <FormControl fullWidth sx={{  }}>
        <InputLabel>Benchmarks</InputLabel>
        <Select
          multiple
          value={selectedBenchmarks}
          onChange={e => setSelectedBenchmarks(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
          input={<OutlinedInput label="Benchmarks" />}
           renderValue={(selected) => {
    const names = selected
      .map(val => benchmarks.find(b => b.id === val)?.name)
      .filter(Boolean);

    const visible = names.slice(0, MAX_VISIBLE);
    const remaining = names.length - MAX_VISIBLE;

    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center', flexWrap: 'nowrap', overflow: 'hidden' }}>
           {visible.map((name:any, index:any) => (
      <Typography
        key={index}
        // title={name}
        sx={{
          maxWidth: '80px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          flexShrink: 0,
        }}
      >
        <Tooltip title={name}>{name}</Tooltip>
        
        {index < visible.length - 1 ? ',' : ''}
      </Typography>
    ))}
        </Box>
        {remaining > 0 && (
          <Tooltip title={names.slice(MAX_VISIBLE).join(', ')}>
            <Box
              sx={{
                bgcolor: '#D0CFF5',
                borderRadius: '50%',
                width: 24,
                height: 24,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 'bold',
                color: '#1D1C2B',
              }}
            >
              +{remaining}
            </Box>
          </Tooltip>
        )}
      </Box>
    );
  }}
          MenuProps={{
            PaperProps: { style: { maxHeight: 300, width: 350 } } }}
        >
          
          <Box sx={{ p: 1, pb: 0 }}>
            <TextField
              size="small"
              placeholder="Search"
              value={search}
              onChange={e => setSearch(e.target.value)}
              fullWidth
              sx={{ mb: 1 }}
            />
          </Box>
          {filteredBenchmarks.map(b => (
            <MenuItem key={b.id} value={b.id}>
              <Checkbox checked={selectedBenchmarks.indexOf(b.id) > -1} />
              <ListItemText primary={b.name} />
            </MenuItem>
          ))}
        </Select>
        
      </FormControl> */}
      <Box
  sx={{
    mb: 2,
    height: {
      xs: '60vh',
      sm: '65vh',
      md: '70vh',
      lg: '75vh',
      xl: '80vh',
    },
    overflowY: 'auto',
  }}
  className="scroll"
>
  {/* <Typography fontWeight={600} sx={{ mt: 2 }}>
    Controls
  </Typography>
  <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
    <FormControlLabel
      control={
        <Checkbox
          checked={controls.failed === 'true'}
          onChange={(e) =>
            setControls((c) => ({
              ...c,
              failed: e.target.checked ? 'true' : 'false',
            }))
          }
          size="small"
        />
      }
      label="Failed"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
    <FormControlLabel
      control={
        <Checkbox
          checked={controls.passed === 'true'}
          onChange={(e) =>
            setControls((c) => ({
              ...c,
              passed: e.target.checked ? 'true' : 'false',
            }))
          }
          size="small"
        />
      }
      label="Passed"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
  </Box>

  <Typography fontWeight={600}>Risk Accepted</Typography>
  <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
    <FormControlLabel
      control={
        <Radio
          checked={riskAccepted === 'include'}
          onChange={() => setRiskAccepted('include')}
          size="small"
        />
      }
      label="Include"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
    <FormControlLabel
      control={
        <Radio
          checked={riskAccepted === 'exclude'}
          onChange={() => setRiskAccepted('exclude')}
          size="small"
        />
      }
      label="Exclude"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
  </Box>

  <Typography fontWeight={600}>Control Descriptions</Typography>
  <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
    <FormControlLabel
      control={
        <Radio
          checked={controlDescriptions === 'include'}
          onChange={() => setControlDescriptions('include')}
          size="small"
        />
      }
      label="Include"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
    <FormControlLabel
      control={
        <Radio
          checked={controlDescriptions === 'exclude'}
          onChange={() => setControlDescriptions('exclude')}
          size="small"
        />
      }
      label="Exclude"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
  </Box>

  <Typography fontWeight={600}>Control Remediations</Typography>
  <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
    <FormControlLabel
      control={
        <Radio
          checked={controlRemediations === 'include'}
          onChange={() => setControlRemediations('include')}
          size="small"
        />
      }
      label="Include"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
    <FormControlLabel
      control={
        <Radio
          checked={controlRemediations === 'exclude'}
          onChange={() => setControlRemediations('exclude')}
          size="small"
        />
      }
      label="Exclude"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
  </Box> */}

  <Typography fontWeight={600}>Report Format</Typography>
  <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
    <FormControlLabel
      control={
        <Radio
          checked={reportFormat === 'pdf'}
          onChange={() => setReportFormat('pdf')}
          size="small"
        />
      }
      label="Pdf"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
    <FormControlLabel
      control={
        <Radio
          checked={reportFormat === 'excel'}
          onChange={() => setReportFormat('excel')}
          size="small"
        />
      }
      label="Excel"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
  </Box>

  {/* <Typography fontWeight={600}>Parameter Impact</Typography>
  <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
    <FormControlLabel
      control={
        <Radio
          checked={parameter_impact === 'include'}
          onChange={() => setParameterImpact('include')}
          size="small"
        />
      }
      label="Include"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
    <FormControlLabel
      control={
        <Radio
          checked={parameter_impact === 'exclude'}
          onChange={() => setParameterImpact('exclude')}
          size="small"
        />
      }
      label="Exclude"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
  </Box>

  <Typography fontWeight={600}>Parameter Log Output</Typography>
  <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
    <FormControlLabel
      control={
        <Radio
          checked={parameter_log_output === 'include'}
          onChange={() => setParameterLogOutput('include')}
          size="small"
        />
      }
      label="Include"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
    <FormControlLabel
      control={
        <Radio
          checked={parameter_log_output === 'exclude'}
          onChange={() => setParameterLogOutput('exclude')}
          size="small"
        />
      }
      label="Exclude"
      sx={{
        width: '120px',
        '.MuiFormControlLabel-label': { fontSize: '12px', fontWeight: 500 },
      }}
    />
  </Box> */}

  <Button
    fullWidth
    variant="contained"
    sx={{ mt: 3 }}
    disabled={downloadLoading}
    onClick={handleDownloadReport}
  >
    {downloadLoading ? (
      <Box display="flex" alignItems="center" gap={1}>
        <CircularProgress size={10} sx={{ color: 'white' }} />
        <Typography sx={{ color: 'white', fontSize: '11px' }}>
          Downloading Report...
        </Typography>
      </Box>
    ) : (
      "Download Report"
    )}
  </Button>
</Box>

    </Box>
  );
};

export default AssetComplianceReportDrawer;
